import GiftIcon from '@atlaskit/icon-lab/core/gift';
import * as React from 'react';

export function SvgPresent() {
  return <GiftIcon label="" testId="ads-refreshed-icon" />;
}
